/* eslint-disable react/prop-types */
import React from 'react';
import MegaMenuMobileLinkBlockContent from './MegaMenuMobileLinkBlockContent';

const MegaMenuMobileColumnItemContent = ({ item }) => {
  if (item.contentType[1] === 'MegaMenuLinksBlock') {
    return <MegaMenuMobileLinkBlockContent linkBlock={item} />;
  }

  return null;
};

export default MegaMenuMobileColumnItemContent;
